/**
 * DecisionFlow — Card
 * Shared component — ui/src/components/shared/Card.jsx
 * S73-UI-03 · Restored: S566 (title + action props stripped in M040 token migration)
 *
 * Props:
 *   title      — card heading (optional)
 *   action     — right-side element, e.g. Button, Pill, or icon (optional)
 *   children   — card body content
 *   className  — additional classes
 */
import React from "react";

export default function Card({ title, action, children, className = "" }) {
  return (
    <div
      className={`rounded-lg border border-[rgb(var(--color-border))] bg-[rgb(var(--color-surface))] text-[rgb(var(--color-text))] shadow-sm p-4 ${className}`}
    >
      {(title || action) && (
        <div className="mb-3 flex items-center justify-between gap-3">
          {title && (
            <h2 className="text-tok-sm font-semibold text-[rgb(var(--color-text))]">
              {title}
            </h2>
          )}
          {action && (
            <div className="flex items-center gap-2 shrink-0">{action}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
